<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.4455 8.15L7.72432 11.05L3 8.15L7.72432 0L12.4455 8.15ZM7.72432 11.9812L3 9.08125L7.72432 16L12.4486 9.08125L7.72432 11.9812Z" fill="#DAF0FF"/>
</svg>
